import ProjectTypeGroup from './ProjectTypeGroup.vue'
import ProjectTypeUTC from './ProjectTypeUTC.vue'

export {
    ProjectTypeGroup,
    ProjectTypeUTC
}